import { coordinateToDecimalString } from "../client/geoCoords";

/** Event-property keys that carry WGS84 coordinates (camelCase + legacy row shapes). */
export const GEO_COORD_ANALYTICS_KEYS = new Set([
  "latitude",
  "longitude",
  "lat",
  "lng",
  "long",
  "Latitude",
  "Longitude",
  "Lat",
  "Lng",
  "Long",
]);

/**
 * Ensure lat/lng fields on analytics payloads are decimal strings (Mixpanel + GA4).
 * Call at the trackEvent boundary so Mapbox numeric taps cannot emit JSON numbers.
 */
export function normalizeGeoCoordAnalyticsProperties(
  properties?: Record<string, unknown>,
): Record<string, unknown> | undefined {
  if (!properties) return properties;
  const out = { ...properties };
  for (const key of Object.keys(out)) {
    if (!GEO_COORD_ANALYTICS_KEYS.has(key)) continue;
    const s = coordinateToDecimalString(out[key] as number | string | null | undefined);
    if (s === undefined) delete out[key];
    else out[key] = s;
  }
  return out;
}

/** Build standard `latitude` / `longitude` string pair for map interaction events. */
export function analyticsGeoCoordPair(
  latitude: number | string | null | undefined,
  longitude: number | string | null | undefined,
): { latitude: string; longitude: string } | undefined {
  const latitudeStr = coordinateToDecimalString(latitude);
  const longitudeStr = coordinateToDecimalString(longitude);
  if (!latitudeStr || !longitudeStr) return undefined;
  return { latitude: latitudeStr, longitude: longitudeStr };
}
